import { useMutation, UseMutationOptions } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  ErrorResponse,
  InitConfirmApproveTerminationRequest,
  InitConfirmOperationResponse,
  initConfirmOperationResponseSchema,
} from '../../../common/validations'
import { ResidentAppError } from '../../../common/error'
import { ConfirmOperationType } from '../../../common/types'

import { post } from 'api/apiClient'
import { rethrowIdentificationRequired } from 'utils/rethrowIdentificationRequired'

export const useAPIConfirmApproveTermination = (
  contractUUID: string,
  locale: string,
  options?: UseMutationOptions<
    InitConfirmOperationResponse,
    ErrorResponse,
    Omit<InitConfirmApproveTerminationRequest, 'locale'>
  >
) => {
  const { mutate, isSuccess, isError, error, data, isPending, variables } =
    useMutation({
      mutationFn: ({ operationData, operationType }) =>
        post(
          `${API_ENDPOINTS.CONTRACTS}/${contractUUID}/confirm-operation/init/contract-termination/approve`,
          {
            operationData,
            operationType,
            locale,
          },
          initConfirmOperationResponseSchema
        ),
      ...options,
    })

  if (isError) {
    rethrowIdentificationRequired(error)

    if (
      variables.operationType ===
      ConfirmOperationType.RESIDENT_APP_CONFIRM_CONTRACT_TERMINATION
    ) {
      throw ResidentAppError.ClientError(
        'TERMINATE_CONTRACT_INIT_CONFIRM_ERROR'
      )
    }

    throw ResidentAppError.ClientError('CONFIRM_OPERATION_GENERIC_ERROR')
  }

  return {
    mutate,
    isSuccess,
    data,
    isPending,
  }
}
